import {
  MediaColumnLayout,
  MediaDialog,
  MediaDisplay,
  MediaToolbar
} from 'v5/design-system/MediaDialog';

/**
 * One image at full size over its blurred backdrop, named in a toolbar below.
 * For a collection with navigation use `MediaLightbox`.
 */
export function SingleImageLightbox({
  src,
  name,
  open,
  onOpenChange
}: {
  src: string;
  /** Shown in the toolbar; also the picture's alt text and the dialog's name. */
  name: string;
  open: boolean;
  onOpenChange(open: boolean): void;
}) {
  return (
    <MediaDialog open={open} onOpenChange={onOpenChange}>
      <MediaDialog.Scene subject={src} backdrop={src}>
        <MediaDisplay.Picture src={src} alt={name} />
      </MediaDialog.Scene>
      <MediaColumnLayout>
        <MediaDisplay>
          <MediaDisplay.Close />
        </MediaDisplay>
        <MediaToolbar>
          <MediaToolbar.Name>{name}</MediaToolbar.Name>
        </MediaToolbar>
      </MediaColumnLayout>
    </MediaDialog>
  );
}
